import React, { useContext } from 'react';

import { useAchControls } from './useAchControls';
import { BaseAddBankAccountFlow } from './BaseAddBankAccountFlow';
import { EditableFieldsContext } from '../../../context';
import { AddBankAccountPromptText } from './AddBankAccountPromptText';
import { Btn } from 'components/btn/Btn';

export const VerificationExpiredFlow = ({ id }: { id: string }) => {
    const { setFieldToEdit } = useContext(EditableFieldsContext);
    const { deleteAch } = useAchControls();

    const retryLinking = async () => {
        await deleteAch();
        setFieldToEdit(id);
    };

    return (
        <BaseAddBankAccountFlow id={id}>
            <div>
                <p className="text-brand-dark">
                    We've encountered an issue trying to link your bank account. Please try again.
                </p>
                <p className="text-grey-1 text-sm">
                    Continue to have issues? Contact Customer Support team at 1-800-727-4715, Option
                    3.
                </p>
                <Btn className="my-4" onClick={retryLinking}>
                    Retry
                </Btn>
                <AddBankAccountPromptText />
            </div>
        </BaseAddBankAccountFlow>
    );
};
